export type FrameStatus = "idle" | "streaming" | "error" | "done";

export function statusColor(status: string): string {
  if (status === "streaming") return "bg-status-streaming";
  if (status === "error") return "bg-status-error";
  return "bg-muted";
}
